/**
 * Created by haiying_zheng on 2017/8/8.
 */
import Vue from 'vue'
import VueResource from 'vue-resource'
import { extend, getCookie, getUrlParam, isPlainObject } from 'tool'

Vue.use(VueResource)

const defaultOpts = {
	url: '',
	type: 'GET',
	errorTips: true,
	data: {},
	onBefore: null,
	onProgress: null,
	onSuccess: null,
	onError: null,
	onComplete: null
}

/**
 * @param opts
 */
export default function (opts) {
	if (!isPlainObject(opts)) {
		throw new TypeError('The type of opts must be Object')
	}

	!opts.data && (opts.data = {})
	if (!isPlainObject(opts.data) && !(opts.data instanceof FormData)) {
		throw new TypeError('The type of opts.data must be plainObject or the instance of FormData')
	}

	if (!opts.url) {
		throw new TypeError('The url is required')
	}

	opts = extend(true, {}, defaultOpts, opts)
	opts.url = '/partner-java' + opts.url
	opts.type = opts.type.toUpperCase()

	// 调用的时候如果上下文为vue实例，则直接从根实例那里获取token
	let vue = null
	if (this && this instanceof Vue) {
		vue = this
		if (opts.data instanceof FormData) {
			opts.data.append('access_token', vue.$root.access_token)
		} else {
			opts.data.access_token = vue.$root.access_token
		}
	}

	Vue.http({
		url: opts.url,
		method: opts.type,
		headers: {
			// Authorization: (window.WebController && window.WebController.getAuthorization && window.WebController.getAuthorization() || ''), //请求头验证
			authorization: opts.data.access_token,
			'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
		},
		responseType: 'json',
		emulateJSON: true,
		params: opts.type === 'GET' && opts.data,
		body: opts.type === 'POST' && opts.data,
		before: opts.onBefore,
		progress: opts.onProgress
	}).then(
		resp => {
			if (typeof resp.body.success === 'boolean' && resp.body.success) {
				typeof opts.onSuccess === 'function' && opts.onSuccess(resp.body.data, resp.body)
			} else {
				opts.errorTips &&
					vue &&
					vue.$message({
						message: resp.body.msg,
						type: 'error',
						dangerouslyUseHTMLString: true
					})
			}
			typeof opts.onComplete === 'function' && opts.onComplete(resp)
		},
		resp => {
			opts.errorTips &&
				vue &&
				vue.$message({
					message: '请求失败，请稍后再试',
					type: 'error'
				})

			typeof opts.onError === 'function' && opts.onError(resp)
			typeof opts.onComplete === 'function' && opts.onComplete(resp)

			console.error(opts.url + '-' + resp.status + '-' + resp.statusText)
		}
	)
}
